import { Component } from '@angular/core';
import { AuthHeaderComponent } from '../../global/auth-header/auth-header.component';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-payment-plan',
  standalone: true,
  imports: [AuthHeaderComponent,MatIconModule],
  templateUrl: './payment-plan.component.html',
  styleUrls: ['./payment-plan.component.css'],
})
export class PaymentPlanComponent {
  constructor(private router: Router) {}

  navigateToPaymentDetail() {
    this.router.navigate(['/payment-details']);
  }
  handleFreeTrial() {
    this.router.navigate(['/login']);
  }
  navigateTo(){
    this.router.navigate(['/verification'])
  }
}
